// src/components/shell/ShortcutsSheet.jsx
import React from 'react';
import Modal from '../Modal.mjs';
import { SHORTCUTS } from './shortcuts';
import '../../css/CommandPalette.css';

/** The keys the app actually listens for — opened with `?`. */
export default function ShortcutsSheet({ open, onClose }) {
    if (!open) return null;

    return (
        <Modal className="qd-shortcuts modal--chrome" onClose={onClose} aria-labelledby="qd-shortcuts-title">
            <div className="modal-header">
                <h1 id="qd-shortcuts-title" className="modal-title">Keyboard shortcuts</h1>
            </div>
            <div className="modal-body">
                <dl className="qd-shortcuts__list">
                    {SHORTCUTS.map((shortcut) => (
                        <div className="qd-shortcuts__row" key={shortcut.label}>
                            <dt>
                                {shortcut.keys.map((key) => <kbd key={key}>{key}</kbd>)}
                            </dt>
                            <dd>
                                {shortcut.label}
                                <span className="qd-shortcuts__scope">{shortcut.scope}</span>
                            </dd>
                        </div>
                    ))}
                </dl>
            </div>
        </Modal>
    );
}
